const MILLION = 1000000
const COMPACT_THRESHOLD = 10000

// Truncates rather than rounds so the label never overstates the count and 999,999 cannot
// become "1000K".
const formatCompact = (count, unit, suffix, locale) => {
  const value = Math.floor(count / (unit / 10)) / 10
  return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(value)}${suffix}`
}

export const formatExactCount = (count, locale) => new Intl.NumberFormat(locale).format(count)

const formatResultsCount = (count, locale) => {
  if (count >= MILLION) return formatCompact(count, MILLION, 'M', locale)
  if (count >= COMPACT_THRESHOLD) return formatCompact(count, 1000, 'K', locale)
  return formatExactCount(count, locale)
}

export default formatResultsCount
